import { Component, OnInit } from "@angular/core";
import { VernostServiceService } from "../../../services/vernost-service.service";
import { Loggerservice } from "../../../services/logger-service";

@Component({
  selector: "app-get-fare-product",
  templateUrl: "./get-fare-product.component.html"
})
export class GetFareProductComponent implements OnInit {
  actionmode: string = "Seacrh";
  headerDivName: string = "addOrEdit"
  showList: boolean = false;
  screentitle: string = "Fare Product Search";
  screen_details: any = [];
  searchlist: boolean = true;
  ViewData: any = [];
  searchresult = false;
  loader = false;
  parent_table = "mst_airline";
  constructor(
    private vernostService: VernostServiceService,
    private logService: Loggerservice
  ) {}

  ngOnInit() {}

  addForm() {
    this.actionmode = "Add";
    this.showList = false;
  }

  searchForm() {
    this.actionmode = "Search";
  }

  searchData() {
    let origin = this.screen_details.origin;
    let destination = this.screen_details.destination;
    let tripvalue = this.screen_details.tripvalue;
    let cabinclass = this.screen_details.cabinclass;

    if (
      origin != undefined &&
      origin != " " &&
      destination != undefined &&
      destination != " " &&
      tripvalue != undefined &&
      tripvalue != " " &&
      cabinclass != undefined
    ) {
      var data = {
        origin: this.screen_details.origin,
        destination: this.screen_details.destination,
        tripvalue: this.screen_details.tripvalue,
        cabinclass: this.screen_details.cabinclass
      };

      this.vernostService.getFareProductRecord(data).subscribe(response => {
        //console.log(JSON.stringify(response));

        this.ViewData = response[0].result[0];
        console.log("HHH=", JSON.stringify(this.ViewData));
        if (this.ViewData.length > 0) {
          this.searchresult = true;
          document.getElementById("errs").innerHTML = "";

          this.logService.create_log_masters(
            "'Component Name':Fare-Product Master,'Action':Srarch Record,'Modified by':" +
              localStorage.getItem("fname") +
              "'Searched Record':" +
              JSON.stringify(this.ViewData),
            "info"
          );
        } else {
          document.getElementById("errs").innerHTML = "Record Not Found";
          this.searchresult = false;
        }
      });
    } else {
      document.getElementById("errs").innerHTML = "Please fill all record";
    }
  }
}
